export enum CustomerTreeTypesEnum {
	UNDEF = 'UNDEF',
	RESORT = 'RESORT',
	SECTOR = 'SECTOR',
	ZONE = 'ZONE'
}